import Box from '@material-ui/core/Box';
import { OrderCriteria } from '@nemuru-eng/js-api-client';

import { ErrorAndIncidenceDescription } from '@/components/shared/components/ErrorAndIncidenceDescription';
import { ErrorIcon } from '@/components/shared/components/ErrorIcon/ErrorIcon';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { loanStatusExternalToDescriptionMap, ORDER_STATUS_DEFINITIONS } from '@/config/orderConfig';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';
import { adjustColorToPalette } from '@/utils/getColorPalette';

export function OrderCriteriaStatusTag({
  orderCriteria,
  hideStatus = false,
  hideSubStatus = false,
}: {
  orderCriteria: OrderCriteria;
  hideStatus?: boolean;
  hideSubStatus?: boolean;
}) {
  const { xs, isMobile } = useScreen();

  const loanStatusExternal = orderCriteria.loanStatusExternal;
  const desistReason = orderCriteria.loan.desistReason;
  const errorDetected = orderCriteria.errorDetected;
  const errorDescription = orderCriteria.errorDescription;
  const isDocumentationWithIncidence = orderCriteria.loanApplicationSelected?.isDocumentationWithIncidence;
  const documentationDescription = orderCriteria.loanApplicationSelected?.documentationDescription;

  const richStatus = ORDER_STATUS_DEFINITIONS[loanStatusExternal];

  const loanStatusExternalDescription = loanStatusExternalToDescriptionMap({ loanStatusExternal, desistReason });
  const { palette } = useCustomTheme();

  if (!richStatus) return <>{loanStatusExternal}</>;

  const color = adjustColorToPalette(richStatus.colorPaletteName, richStatus.colorType, palette);

  return (
    <>
      <Box display={'flex'} alignItems={'center'} minWidth={0}>
        <Box bgcolor={color} className={'circle mr-2'} style={{ marginBottom: '-1px' }} />
        <Box display={'flex'} flexDirection={'column'} minWidth={0}>
          {hideStatus !== true && (
            <Font variant={'body2'} color={'textPrimary'}>
              <Text tId={richStatus.SECTION_T_ID} />
            </Font>
          )}
          <Box style={{ lineHeight: 1.43, display: 'flex', minWidth: 0 }}>
            {hideSubStatus !== true && loanStatusExternalDescription && (
              <Font
                variant={'caption'}
                color={'textSecondary'}
                className={'subtag overflow-text-ellipsis'}
                style={{ whiteSpace: 'break-spaces' }}
              >
                <Text tId={loanStatusExternalDescription} />
              </Font>
            )}
            {(errorDetected || isDocumentationWithIncidence) && (
              <Box
                className={isMobile ? 'overflow-text-ellipsis' : 'line-clamp-2'}
                style={{
                  maxWidth: !xs ? '' : '86px',
                }}
              >
                {ErrorAndIncidenceDescription({
                  errorDetected,
                  errorDescription,
                  isDocumentationWithIncidence,
                  documentationDescription,
                })}
              </Box>
            )}
          </Box>
        </Box>
        {
          <Box ml={2}>
            <ErrorIcon errorDetected={errorDetected} isDocumentationWithIncidence={isDocumentationWithIncidence} />
          </Box>
        }
      </Box>
    </>
  );
}
